import $x from '@/utils/$x';

/**
 * 短信模板列表
 * @param {*} params
 * @returns
 */
export async function getSMSTemplate(params) {
  return $x.post('/clue/user/sms/templates', params);
}

/**
 * 线索用户列表
 * @param {*} params
 * @returns
 */
export async function getPotentialUserList(params) {
  return $x.post('/clue/user/list', params);
}

/**
 * 选择用户发送短信
 * @param {*} params
 * @returns
 */
export async function sendSms(params) {
  return $x.post('/clue/user/sendSms', params);
}

/**
 * 批量导入线索用户
 * @param {*} params
 * @returns
 */
export async function importClueUser(params) {
  return $x.post('/clue/user/importClueUser', params);
}

/**
 * 导入文件后发送短信
 * @param {*} params
 * @returns
 */
export async function sendSmsByBatchId(params) {
  return $x.post('/clue/user/sendSmsByBatchId', params);
}

/**
 * 查询所有标签
 * @param {*} params
 * @returns
 */
export async function getTagList(params) {
  return $x.post('/clue/tag/pageTag', params);
}

/**
 * 删除标签
 * @param {*} params
 * @returns
 */
export async function deleteTag(params) {
  return $x.post('/clue/tag/delTag', params);
}

/**
 * 校验标签是否有用户
 * @param {*} params
 * @returns
 */
export async function checkTag(params) {
  return $x.post('/clue/tag/checkTag', params);
}

/**
 * 修改和添加标签
 * @param {*} params
 * @returns
 */
export async function saveTag(params) {
  return $x.post('/clue/tag/saveTag', params);
}

/**
 * 根据标签发短信
 * @param {*} params
 * @returns
 */
export async function sendSmsByTag(params) {
  return $x.post('/clue/tag/sendSmsByTag', params);
}

/**
 * 创建方式枚举
 * @param {*} params
 * @returns
 */
export async function addTypeEnum(params) {
  return $x.post('/clue/user/listAddType', params);
}

/**
 * 查询线索用户详情
 * @param {*} params
 * @returns
 */
export async function getClueUserDetail(params) {
  return $x.post('/clue/user/getClueUser', params);
}

/**
 * 查询用户发短信记录
 * @param {*} params
 * @returns
 */
export async function sendUserSmsRecord(params) {
  return $x.post('/clue/user/pageClueUserSendSms', params);
}

/**
 * 查询用户录入记录
 * @param {*} params
 * @returns
 */
export async function pageClueUserRecord(params) {
  return $x.post('/clue/user/pageClueUserRecord', params);
}

/**
 * 查询所属员工列表
 * @param {*} params
 * @returns
 */
export async function queryFollowedUserModel(params) {
  return $x.post('/clue/user/queryFollowedUserModel', params);
}

/**
 * 保存用户标签
 * @param {*} params
 * @returns
 */
export async function saveClueUserTag(params) {
  return $x.post('/clue/user/saveClueUserTag', params);
}
